import devSection from './boards.dev';
import prdSection from './boards.prd';

const getConfig = (dev, prd) => {
  return process.env.NODE_ENV === 'production' ? prd : dev;
};

export const BOARD_CONFIG = getConfig(devSection, prdSection);
